import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=d8fa1b70&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=js&"
export * from "./videoList.vue?vue&type=script&lang=js&"
import style1 from "./videoList.vue?vue&type=style&index=1&id=d8fa1b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa1b70",
  null
  
)

export default component.exports